import { LogoWordmark } from '@cbhq/cds-web/icons/LogoWordmark';
import './Div/index.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from './Div/Div.js';
function CoinbaseLogo() {
  return /*#__PURE__*/jsx(Div, {
    as: "span",
    display: "contents",
    children: /*#__PURE__*/jsx(LogoWordmark, {})
  });
}
export { CoinbaseLogo };
//# sourceMappingURL=CoinbaseLogo.js.map
